export const GENERAL_INFO_LABEL = 'GENERAL INFO';
export const DEVICES_DOCS_LABEL = 'DEVICES & DOCUMENTATION';

export default {};
